<template>
    <input type="text" class="eod-daterange d-none" ref="picker">
</template>
<style lang="css">
@import url('flatpickr');

.eod-daterange + .flatpickr-calendar{
    box-shadow: none !important;
}
</style>
<script lang="ts">
import flatpickr from "flatpickr";
import { Dutch } from "flatpickr/dist/l10n/nl.js"

export default {
    name: 'eod-daterange',
    props: {
        value: {
            type: Array,
            default: () => ([])
        }
    },
    data: () => ({
        instance: null
    }),
    mounted() {
        if(this.instance){
            this.instance.destroy();
        }
        this.instance = flatpickr(this.$refs.picker, {
            inline: true,
            mode: 'range',
            locale: Dutch,
            onChange: (selectedDates, dateStr, instance) => {
                const val = this.value;
                if(selectedDates[0]){
                    val[0] = this.$moment(selectedDates[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss');
                }
                if(selectedDates[1]){
                    val[1] = this.$moment(selectedDates[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss');
                }

                this.$emit('input', val);
            }
        });

        this.instance.setDate(this.value);
    }
}
</script>